import styled from 'styled-components'

export const Container = styled.div`
  .calc-right .calc-eq {
    right: 8px;
  }
`
